import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { ChangeLogTable, LayoutSidebar, PaymentReviewSidebar, SectionHeader } from 'components';
import { MPContent } from 'screens/MakePayment/styles';
import { selectCalculatorChangeLog, selectCalculatorPayees, selectCalculatorPaymentSet, selectCalculatorResults } from 'store/TipCalculator';
import { ISite } from 'types';
import { buildTipCalculatorParticipants, calculateTipCalculatorPaymentTotals, siteUsesHoldbacks } from 'utils';

interface IChangeLogProps {
  onBack: () => void;
  site: ISite;
  pageHeaderContent: React.ReactNode;
}

const ChangeLog = ({ site, onBack, pageHeaderContent }: IChangeLogProps) => {
  const payees = useSelector(selectCalculatorPayees());
  const paymentSet = useSelector(selectCalculatorPaymentSet());
  const tipCalcResults = useSelector(selectCalculatorResults());
  const changeLogEntries = useSelector(selectCalculatorChangeLog());

  const participants = useMemo(() => buildTipCalculatorParticipants(tipCalcResults), [tipCalcResults]);
  const totals = useMemo(() => calculateTipCalculatorPaymentTotals(payees), [payees]);

  return (
    <LayoutSidebar
      content={
        <>
          {pageHeaderContent}
          <MPContent data-cy="change-log-content">
            <SectionHeader data-cy="change-log-header" title={`Changes (${changeLogEntries.length})`} />
            <ChangeLogTable changeLogEntries={changeLogEntries} />
          </MPContent>
        </>
      }
      sidebar={
        <PaymentReviewSidebar businessDate={dayjs(paymentSet?.date)} onBack={onBack} showCash={totals.cash > 0} showHoldbacks={siteUsesHoldbacks(site.settings?.holdback)} totals={totals} participants={participants} isTipCalculator />
      }
    />
  );
};

export default ChangeLog;
